export const catalog = {
  стильный: {
    1: {
      images: `./img/catalog/dunobil/Dunobil-Luft-Klein.png`,
      title: `Dunobil Luft Klein`,
      text: `Очень компактный и достаточно мощный цифровой беспроводной автокомпрессор <a href="https://shop.dunobil.ru/product/luft_klein.html" target="_blank" rel="noopener noreferrer">Dunobil Luft Klein</a>. Легко помещается в перчаточном ящике. Работает еще и как power-bank`,
      logoImages: `./img/logo/dunobil.png`,
      filter: [`парашют`],
      code: false,
      link: `https://shop.dunobil.ru/product/luft_klein.html`,
    },
    2: {
      images: `./img/catalog/starwind/Moon-Edition-VC.png`,
      title: `Moon Edition VC`,
      text: `Стильный автомобильный пылесос <a href="https://starwind.com.ru/catalog/item/1478650/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">Moon Edition VC</a>, с простым управлением и съемными насадками, наведет полный порядок в салоне вашего автомобиля.`,
      logoImages: `./img/logo/starwind.png`,
      filter: [`щит`],
      code: false,
      link: `https://starwind.com.ru/catalog/item/1478650/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    3: {
      images: `./img/catalog/starwind/Ember-Edition-VC.png`,
      title: `Ember Edition VC`,
      text: `Аккумуляторный пылесос <a href="https://starwind.com.ru/catalog/item/1478646/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">StarWind Ember Edition VC</a> для легкой уборки салона автомобиля привлекает внимание необычной формой и мобильностью.`,
      logoImages: `./img/logo/starwind.png`,
      filter: [`танк`],
      code: false,
      link: `https://starwind.com.ru/catalog/item/1478646/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    4: {
      images: `./img/catalog/hyundai/HYUNDAI-H-MC300.png`,
      title: `HYUNDAI H-MC300`,
      text: `Cаундбар <a href="https://hyundai-electronics.com.ru/catalog/item/1214631/?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">HYUNDAI H-MC300</a> обеспечит качественную звукопередачу и полное погружение в атмосферу происходящего на экране.`,
      logoImages: `./img/logo/hyundai.png`,
      filter: [`дом`],
      code: false,
      link: `https://hyundai-electronics.com.ru/catalog/item/1214631/?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    5: {
      images: `./img/catalog/berkut/BERKUT-SPEC-2M.png`,
      title: `BERKUT SPEC-2M`,
      text: `Автомобильный компрессор <a href="https://shop.berkut-compressor.ru/tproduct/301236487-363486801181-berkut-spec-2m" target="_blank" rel="noopener noreferrer">BERKUT SPEC-2M</a> с электронным управлением в стильном защитном металлическом кофре, с защитой от перегрева и функцией автоотключения.`,
      logoImages: `./img/logo/berkut.png`,
      filter: [`вертолет`],
      code: true,
      link: `https://shop.berkut-compressor.ru/tproduct/301236487-363486801181-berkut-spec-2m`,
    },
    6: {
      images: `./img/catalog/starwind/SW-LED55UB401.png`,
      title: `SW-LED55UB401`,
      text: `Четкое и сочное изображение телевизора <a href="https://starwind.com.ru/catalog/item/1451712/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">SW-LED55UB401</a> с интуитивным меню позволит насладиться любимой передачей, а Алиса расскажет новости спорта.`,
      logoImages: `./img/logo/starwind.png`,
      filter: [`подарок`],
      code: false,
      link: `https://starwind.com.ru/catalog/item/1451712/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    7: {
      images: `./img/catalog/starwind/SAW5522.png`,
      title: `SAW5522`,
      text: `Мойка воздуха <a href="https://starwind.com.ru/catalog/item/1517834/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">STARWIND SAW5522</a> поможет создать комфортный микроклимат в семье.`,
      logoImages: `./img/logo/starwind.png`,
      filter: [`звезда`],
      code: false,
      link: `https://starwind.com.ru/catalog/item/1517834/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    8: {
      images: `./img/catalog/dunobil/Dunobil-Strom-Wireless.png`,
      title: `Dunobil Strom Wireless`,
      text: `Автомобильное пуско-зарядное устройство <a href="https://dunobil.ru/stromwireless" target="_blank" rel="noopener noreferrer">Dunobil Strom Wireless</a>, а также power-bank с функцией беспроводной зарядки гаджетов`,
      logoImages: `./img/logo/dunobil.png`,
      filter: [`салют`],
      code: false,
      link: `https://dunobil.ru/stromwireless`,
    },
  },
  спортивный: {
    1: {
      images: `./img/catalog/berkut/BERKUT-Smart-Power-SVC-300.png`,
      title: `BERKUT Smart Power SVC-300`,
      text: `Удобный в использовании автопылесос <a href="https://shop.berkut-compressor.ru/tproduct/301239561-890449084081-berkut-svc-300" target="_blank" rel="noopener noreferrer">BERKUT Smart Power SVC-300</a> с современной системой фильтрации. Мощный, с большим пылесборником и несколькими насадками.`,
      logoImages: `./img/logo/berkut.png`,
      filter: [`парашют`],
      code: true,
      link: `https://shop.berkut-compressor.ru/tproduct/301239561-890449084081-berkut-svc-300`,
    },
    2: {
      images: `./img/catalog/berkut/BERKUT-SPEC-2M.png`,
      title: `BERKUT SPEC-2M`,
      text: `Автомобильный компрессор <a href="https://shop.berkut-compressor.ru/tproduct/301236487-363486801181-berkut-spec-2m" target="_blank" rel="noopener noreferrer">BERKUT SPEC-2M</a> с электронным управлением в стильном защитном металлическом кофре, с защитой от перегрева и функцией автоотключения. `,
      logoImages: `./img/logo/berkut.png`,
      filter: [`щит`],
      code: true,
      link: `https://shop.berkut-compressor.ru/tproduct/301236487-363486801181-berkut-spec-2m`,
    },
    3: {
      images: `./img/catalog/dunobil/Dunobil-Luft-Power.png`,
      title: `Dunobil Luft Power`,
      text: `Мощный беспроводной автокомпрессор <a href="https://shop.dunobil.ru/product/luft_power.html" target="_blank" rel="noopener noreferrer">Dunobil Luft Power</a> с батареей 8000 mAh. Не только накачает колеса, зарядит гаджеты, но и запустит двигатель с разряженной АКБ.`,
      logoImages: `./img/logo/dunobil.png`,
      filter: [`танк`],
      code: false,
      link: `https://shop.dunobil.ru/product/luft_power.html`,
    },
    4: {
      images: `./img/catalog/starwind/SW-LED58UB405.png`,
      title: `SW-LED58UB405`,
      text: `Телевизор <a href="https://starwind.com.ru/catalog/item/1527916/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">SW-LED58UB405</a> позволит устроить у вас дома настоящий кинотеатр. Стильный, тонкий корпус идеально смотрится на стене вашего дома. `,
      logoImages: `./img/logo/starwind.png`,
      filter: [`дом`],
      code: false,
      link: `https://starwind.com.ru/catalog/item/1527916/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    5: {
      images: `./img/catalog/husqvarna/Husqvarna-120iB.png`,
      title: `Husqvarna 120iB`,
      text: `Аккумуляторный воздуходув <a href="https://www.husqvarna.com/ru/vozdukhoduvy/120ib-bez-akkumuliatora-i-zariadnogo-ustroistva/" target="_blank" rel="noopener noreferrer">Husqvarna 120iB</a> - легкий, удобный и простой в использовании, имеет три режима работы по силе воздушного потока и низкий уровень шума.`,
      logoImages: `./img/logo/husqvarna.png`,
      filter: [`вертолет`],
      code: false,
      link: `https://www.husqvarna.com/ru/vozdukhoduvy/120ib-bez-akkumuliatora-i-zariadnogo-ustroistva/`,
    },
    6: {
      images: `./img/catalog/starwind/SW-LED55UB401.png`,
      title: `SW-LED55UB401`,
      text: `Четкое и сочное изображение телевизора <a href="https://starwind.com.ru/catalog/item/1451712/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">SW-LED55UB401</a> с интуитивным меню позволит насладиться любимой передачей, а Алиса расскажет новости спорта.`,
      logoImages: `./img/logo/starwind.png`,
      filter: [`подарок`],
      code: false,
      link: `https://starwind.com.ru/catalog/item/1451712/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    7: {
      images: `./img/catalog/berkut/BERKUT-JSL-15000.png`,
      title: `BERKUT JSL-15000`,
      text: `Компактное мощное пускозарядное устройство <a href="https://shop.berkut-compressor.ru/tproduct/301238627-125638714611-berkut-jsl-15000" target="_blank" rel="noopener noreferrer">BERKUT JSL-15000</a> для запуска двигателя с севшим АКБ. Может служить также как power bank для зарядки гаджетов.`,
      logoImages: `./img/logo/berkut.png`,
      filter: [`звезда`],
      code: true,
      link: `https://shop.berkut-compressor.ru/tproduct/301238627-125638714611-berkut-jsl-15000`,
    },
    8: {
      images: `./img/catalog/dunobil/Dunobil-Honor-Duo-Magnet.png`,
      title: `Dunobil Honor Duo Magnet`,
      text: `Видеорегистратор <a href="https://shop.dunobil.ru/product/strom-wireless.html" target="_blank" rel="noopener noreferrer">Dunobil Honor Duo Magnet</a> с высоким разрешением записи и удобным магнитным креплением`,
      logoImages: `./img/logo/dunobil.png`,
      filter: [`салют`],
      code: false,
      link: `https://shop.dunobil.ru/product/strom-wireless.html`,
    },
  },
  хозяйственный: {
    1: {
      images: `./img/catalog/husqvarna/Husqvarna-120i.png`,
      title: `Husqvarna 120i`,
      text: `Аккумуляторная цепная пила <a href="https://www.husqvarna.com/ru/tsepnye-pily/120i-bez-akkumuliatora-i-zariadnogo-ustroistva/" target="_blank" rel="noopener noreferrer">Husqvarna 120i</a> - легкая и простая в использовании, идеально подойдет для заготовки дров и обрезки ветвей, позволяя работать и не беспокоить соседей.`,
      logoImages: `./img/logo/husqvarna.png`,
      filter: [`парашют`],
      code: false,
      link: `https://www.husqvarna.com/ru/tsepnye-pily/120i-bez-akkumuliatora-i-zariadnogo-ustroistva/`,
    },
    2: {
      images: `./img/catalog/husqvarna/Husqvarna-120iB.png`,
      title: `Husqvarna 120iB`,
      text: `Аккумуляторный воздуходув <a href="https://www.husqvarna.com/ru/vozdukhoduvy/120ib-bez-akkumuliatora-i-zariadnogo-ustroistva/" target="_blank" rel="noopener noreferrer">Husqvarna 120iB</a> - легкий, удобный и простой в использовании, имеет три режима работы по силе воздушного потока и низкий уровень шума.`,
      logoImages: `./img/logo/husqvarna.png`,
      filter: [`щит`],
      code: false,
      link: `https://www.husqvarna.com/ru/vozdukhoduvy/120ib-bez-akkumuliatora-i-zariadnogo-ustroistva/`,
    },
    3: {
      images: `./img/catalog/dunobil/Dunobil-Luft-Power.png`,
      title: `Dunobil Luft Power`,
      text: `Мощный беспроводной автокомпрессор <a href="https://shop.dunobil.ru/product/luft_power.html" target="_blank" rel="noopener noreferrer">Dunobil Luft Power</a> с батареей 8000 mAh. Не только накачает колеса, зарядит гаджеты, но и запустит двигатель с разряженной АКБ.`,
      logoImages: `./img/logo/dunobil.png`,
      filter: [`танк`],
      code: false,
      link: `https://shop.dunobil.ru/product/luft_power.html`,
    },
    4: {
      images: `./img/catalog/hyundai/HYUNDAI-H-HA650.png`,
      title: `HYUNDAI H-HA650`,
      text: `Система динамиков 2.1 (60Вт + 90Вт беспроводной сабвуфер) саундбара <a href="https://hyundai-electronics.com.ru/catalog/item/1472788/?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">H-HA650</a> значительно улучшит встроенную аудиосистему вашего телевизора.`,
      logoImages: `./img/logo/hyundai.png`,
      filter: [`дом`],
      code: false,
      link: `https://hyundai-electronics.com.ru/catalog/item/1472788/?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    5: {
      images: `./img/catalog/dunobil/Dunobil-Honor-Duo-Magnet.png`,
      title: `Dunobil Honor Duo Magnet`,
      text: `Видеорегистратор <a href="https://shop.dunobil.ru/product/honor_duo_magnet.html" target="_blank" rel="noopener noreferrer">Dunobil Honor Duo Magnet</a> с высоким разрешением записи и удобным магнитным креплением`,
      logoImages: `./img/logo/dunobil.png`,
      filter: [`вертолет`],
      code: false,
      link: `https://shop.dunobil.ru/product/honor_duo_magnet.html`,
    },
    6: {
      images: `./img/catalog/starwind/SW-LED58UB405.png`,
      title: `SW-LED58UB405`,
      text: `Телевизор <a href="https://starwind.com.ru/catalog/item/1527916/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">SW-LED58UB405</a> позволит устроить у вас дома настоящий кинотеатр. Стильный, тонкий корпус идеально смотрится на стене вашего дома. `,
      logoImages: `./img/logo/starwind.png`,
      filter: [`подарок`],
      code: false,
      link: `https://starwind.com.ru/catalog/item/1527916/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    7: {
      images: `./img/catalog/husqvarna/Husqvarna-PW-360.png`,
      title: `Husqvarna PW 360`,
      text: `Мойка высокого давления <a href="https://www.husqvarna.com/ru/moiki-vysokogo-davleniya/pw360/" target="_blank" rel="noopener noreferrer">Husqvarna PW 360</a> - компактная модель с повышенным моторесурсом, предназначенная для мойки автомобилей, садовой техники, а также для ухода за домом и участком.`,
      logoImages: `./img/logo/husqvarna.png`,
      filter: [`звезда`],
      code: false,
      link: `https://www.husqvarna.com/ru/moiki-vysokogo-davleniya/pw360/`,
    },
    8: {
      images: `./img/catalog/berkut/BERKUT-Digital-PRO.png`,
      title: `BERKUT Digital PRO`,
      text: `Универсальный современный цифровой манометр <a href="https://shop.berkut-compressor.ru/tproduct/301238549-298157021581-berkut-digital-pro" target="_blank" rel="noopener noreferrer">BERKUT Digital PRO</a> – это удобное и точное устройство для измерения давления в шинах автомобиля. Имеет форму карабина и большой дисплей с яркой подсветкой.`,
      logoImages: `./img/logo/berkut.png`,
      filter: [`салют`],
      code: true,
      link: `https://shop.berkut-compressor.ru/tproduct/301238549-298157021581-berkut-digital-pro`,
    },
  },
  красивый: {
    1: {
      images: `./img/catalog/berkut/BERKUT-Digital-PRO.png`,
      title: `BERKUT Digital PRO`,
      text: `Универсальный современный цифровой манометр <a href="https://shop.berkut-compressor.ru/tproduct/301238549-298157021581-berkut-digital-pro" target="_blank" rel="noopener noreferrer">BERKUT Digital PRO</a> – это удобное и точное устройство для измерения давления в шинах автомобиля. Имеет форму карабина и большой дисплей с яркой подсветкой.`,
      logoImages: `./img/logo/berkut.png`,
      filter: [`парашют`],
      code: true,
      link: `https://shop.berkut-compressor.ru/tproduct/301238549-298157021581-berkut-digital-pro`,
    },
    2: {
      images: `./img/catalog/hyundai/HYUNDAI-H-MC160.png`,
      title: `HYUNDAI H-MC160`,
      text: `Стильная портативная акустика Hyundai <a href="https://hyundai-electronics.com.ru/catalog/item/1098376?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">H-MC160</a>, с переливающейся подсветкой корпуса устройства, поможет вам устроить вечеринку.`,
      logoImages: `./img/logo/hyundai.png`,
      filter: [`щит`],
      code: false,
      link: `https://hyundai-electronics.com.ru/catalog/item/1098376?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    3: {
      images: `./img/catalog/dunobil/Dunobil-Spiegel-Duo-Touch.png`,
      title: `Dunobil Spiegel Duo Touch `,
      text: `Видеорегистратор <a href="https://shop.dunobil.ru/product/spiegel_duo_touch.html" target="_blank" rel="noopener noreferrer">Dunobil Spiegel Duo</a> Touch с сенсорным управлением крепится на штатное зеркало автомобиля и не занимает место на лобовом стекле.`,
      logoImages: `./img/logo/dunobil.png`,
      filter: [`танк`],
      code: false,
      link: `https://shop.dunobil.ru/product/spiegel_duo_touch.html`,
    },
    4: {
      images: `./img/catalog/hyundai/H-LED65FU7002.png`,
      title: `H-LED65FU7002`,
      text: `Телевизор <a href="https://hyundai-electronics.com.ru/catalog/item/1460090?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">Hyundai H-LED65FU7002</a> с большим экраном обеспечит вас высококачественным изображением. Цифровые тюнеры позволят принимать сигналы разных форматов вещания. `,
      logoImages: `./img/logo/hyundai.png`,
      filter: [`дом`],
      code: false,
      link: `https://hyundai-electronics.com.ru/catalog/item/1460090?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    5: {
      images: `./img/catalog/berkut/BERKUT-Smart-Power-SVC-300.png`,
      title: `BERKUT Smart Power SVC-300`,
      text: `Удобный в использовании автопылесос <a href="https://shop.berkut-compressor.ru/tproduct/301239561-890449084081-berkut-svc-300" target="_blank" rel="noopener noreferrer">BERKUT Smart Power</a> SVC-300 с современной системой фильтрации. Мощный, с большим пылесборником и несколькими насадками.`,
      logoImages: `./img/logo/berkut.png`,
      filter: [`вертолет`],
      code: true,
      link: `https://shop.berkut-compressor.ru/tproduct/301239561-890449084081-berkut-svc-300`,
    },
    6: {
      images: `./img/catalog/dunobil/Dunobil-Luft-Klein.png`,
      title: `Dunobil Luft Klein`,
      text: `Очень компактный и достаточно мощный цифровой беспроводной автокомпрессор <a href="https://shop.dunobil.ru/product/luft_klein.html" target="_blank" rel="noopener noreferrer">Dunobil Luft Klein</a>. Легко помещается в перчаточном ящике. Работает еще и как power-bank`,
      logoImages: `./img/logo/dunobil.png`,
      filter: [`подарок`],
      code: false,
      link: `https://shop.dunobil.ru/product/luft_klein.html`,
    },
    7: {
      images: `./img/catalog/hyundai/H-LED55FU7001.png`,
      title: `H-LED55FU7001`,
      text: `Диагональ экрана телевизора <a href="https://hyundai-electronics.com.ru/catalog/item/1406135?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">HYUNDAI H-LED55FU7001</a> в 55 дюймов обеспечивает полноценное погружение в происходящее на экране.`,
      logoImages: `./img/logo/hyundai.png`,
      filter: [`звезда`],
      code: false,
      link: `https://hyundai-electronics.com.ru/catalog/item/1406135?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    8: {
      images: `./img/catalog/hyundai/HYUNDAI-H-HA650.png`,
      title: `HYUNDAI H-HA650`,
      text: `Система динамиков 2.1 (60Вт + 90Вт беспроводной сабвуфер) саундбара <a href="https://hyundai-electronics.com.ru/catalog/item/1472788/?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">H-HA650</a> значительно улучшит встроенную аудиосистему вашего телевизора.`,
      logoImages: `./img/logo/hyundai.png`,
      filter: [`салют`],
      code: false,
      link: `https://hyundai-electronics.com.ru/catalog/item/1472788/?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
  },
  смелый: {
    1: {
      images: `./img/catalog/husqvarna/Husqvarna-120i.png`,
      title: `Husqvarna 120i`,
      text: `Аккумуляторная цепная пила <a href="https://www.husqvarna.com/ru/tsepnye-pily/120i-bez-akkumuliatora-i-zariadnogo-ustroistva/" target="_blank" rel="noopener noreferrer">Husqvarna 120i</a> - легкая и простая в использовании, идеально подойдет для заготовки дров и обрезки ветвей, позволяя работать и не беспокоить соседей.`,
      logoImages: `./img/logo/husqvarna.png`,
      filter: [`парашют`],
      code: false,
      link: `https://www.husqvarna.com/ru/tsepnye-pily/120i-bez-akkumuliatora-i-zariadnogo-ustroistva/`,
    },
    2: {
      images: `./img/catalog/berkut/BERKUT-JSL-15000.png`,
      title: `BERKUT JSL-15000`,
      text: `Компактное мощное пускозарядное устройство <a href="https://shop.berkut-compressor.ru/tproduct/301238627-125638714611-berkut-jsl-15000" target="_blank" rel="noopener noreferrer">BERKUT JSL-15000</a> для запуска двигателя с севшим АКБ. Может служить также как power bank для зарядки гаджетов.`,
      logoImages: `./img/logo/berkut.png`,
      filter: [`щит`],
      code: true,
      link: `https://shop.berkut-compressor.ru/tproduct/301238627-125638714611-berkut-jsl-15000`,
    },
    3: {
      images: `./img/catalog/starwind/Ember-Edition-VC.png`,
      title: `Ember Edition VC`,
      text: `Аккумуляторный пылесос <a href="https://starwind.com.ru/catalog/item/1478646/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">StarWind Ember Edition VC</a> для легкой уборки салона автомобиля привлекает внимание необычной формой и мобильностью.`,
      logoImages: `./img/logo/starwind.png`,
      filter: [`танк`],
      code: false,
      link: `https://starwind.com.ru/catalog/item/1478646/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    4: {
      images: `./img/catalog/starwind/SW-LED55UB401.png`,
      title: `SW-LED55UB401`,
      text: `Четкое и сочное изображение телевизора <a href="https://starwind.com.ru/catalog/item/1451712/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">SW-LED55UB401</a> с интуитивным меню позволит насладиться любимой передачей, а Алиса расскажет новости спорта.`,
      logoImages: `./img/logo/starwind.png`,
      filter: [`дом`],
      code: false,
      link: `https://starwind.com.ru/catalog/item/1451712/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    5: {
      images: `./img/catalog/dunobil/Dunobil-Spiegel-Duo-Touch.png`,
      title: `Dunobil Spiegel Duo Touch`,
      text: `Видеорегистратор <a href="https://shop.dunobil.ru/product/spiegel_duo_touch.html" target="_blank" rel="noopener noreferrer">Dunobil Spiegel Duo Touch</a> с сенсорным управлением крепится на штатное зеркало автомобиля и не занимает место на лобовом стекле.`,
      logoImages: `./img/logo/dunobil.png`,
      filter: [`вертолет`],
      code: false,
      link: `https://shop.dunobil.ru/product/spiegel_duo_touch.html`,
    },
    6: {
      images: `./img/catalog/starwind/Moon-Edition-VC.png`,
      title: `Moon Edition VC`,
      text: `Стильный автомобильный пылесос <a href="https://starwind.com.ru/catalog/item/1478650/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">Moon Edition VC</a>, с простым управлением и съемными насадками, наведет полный порядок в салоне вашего автомобиля.`,
      logoImages: `./img/logo/starwind.png`,
      filter: [`подарок`],
      code: false,
      link: `https://starwind.com.ru/catalog/item/1478650/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    7: {
      images: `./img/catalog/husqvarna/Husqvarna-PW-360.png`,
      title: `Husqvarna PW 360`,
      text: `Мойка высокого давления <a href="https://www.husqvarna.com/ru/moiki-vysokogo-davleniya/pw360/" target="_blank" rel="noopener noreferrer">Husqvarna PW 360</a> - компактная модель с повышенным моторесурсом, предназначенная для мойки автомобилей, садовой техники, а также для ухода за домом и участком.`,
      logoImages: `./img/logo/husqvarna.png`,
      filter: [`звезда`],
      code: false,
      link: `https://www.husqvarna.com/ru/moiki-vysokogo-davleniya/pw360/`,
    },
    8: {
      images: `./img/catalog/berkut/BERKUT-VL-1050.png`,
      title: `BERKUT VL-1050`,
      text: `Компактный аккумуляторный велосипедный насос <a href="https://shop.berkut-compressor.ru/tproduct/301238360-254868289751-berkut-vl-1050" target="_blank" rel="noopener noreferrer">BERKUT VL-1050</a> сделает поездки более комфортными и приятными. Заряжается через разъем Micro USB 5V и имеет крепление на раму велосипеда.`,
      logoImages: `./img/logo/berkut.png`,
      filter: [`салют`],
      code: true,
      link: `https://shop.berkut-compressor.ru/tproduct/301238360-254868289751-berkut-vl-1050`,
    },
  },
  романтичный: {
    1: {
      images: `./img/catalog/starwind/SAW5522.png`,
      title: `SAW5522`,
      text: `Мойка воздуха <a href="https://starwind.com.ru/catalog/item/1517834/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">STARWIND SAW5522</a> поможет создать комфортный микроклимат в семье.`,
      logoImages: `./img/logo/starwind.png`,
      filter: [`парашют`],
      code: false,
      link: `https://starwind.com.ru/catalog/item/1517834/?utm_source=merlion_starwind&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    2: {
      images: `./img/catalog/hyundai/H-LED55FU7001.png`,
      title: `H-LED55FU7001`,
      text: `Диагональ экрана телевизора <a href="https://hyundai-electronics.com.ru/catalog/item/1406135?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">HYUNDAI H-LED55FU7001</a> в 55 дюймов обеспечивает полноценное погружение в происходящее на экране.`,
      logoImages: `./img/logo/hyundai.png`,
      filter: [`щит`],
      code: false,
      link: `https://hyundai-electronics.com.ru/catalog/item/1406135?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    3: {
      images: `./img/catalog/berkut/BERKUT-VL-1050.png`,
      title: `BERKUT VL-1050`,
      text: `Компактный аккумуляторный велосипедный насос <a href="https://shop.berkut-compressor.ru/tproduct/301238360-254868289751-berkut-vl-1050" target="_blank" rel="noopener noreferrer">BERKUT VL-1050</a> сделает поездки более комфортными и приятными. Заряжается через разъем Micro USB 5V и имеет крепление на раму велосипеда.`,
      logoImages: `./img/logo/berkut.png`,
      filter: [`танк`],
      code: true,
      link: `https://shop.berkut-compressor.ru/tproduct/301238360-254868289751-berkut-vl-1050`,
    },
    4: {
      images: `./img/catalog/hyundai/H-LED65FU7002.png`,
      title: `H-LED65FU7002`,
      text: `Телевизор <a href="https://hyundai-electronics.com.ru/catalog/item/1460090?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">Hyundai H-LED65FU7002</a> с большим экраном обеспечит вас высококачественным изображением. Цифровые тюнеры позволят принимать сигналы разных форматов вещания.`,
      logoImages: `./img/logo/hyundai.png`,
      filter: [`дом`],
      code: false,
      link: `https://hyundai-electronics.com.ru/catalog/item/1460090?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    5: {
      images: `./img/catalog/dunobil/Dunobil-Strom-Wireless.png`,
      title: `Dunobil Strom Wireless`,
      text: `Автомобильное пускозарядное устройство <a href="https://dunobil.ru/stromwireless" target="_blank" rel="noopener noreferrer">Dunobil Strom Wireless</a>, а также power-bank с функцией беспроводной зарядки гаджетов`,
      logoImages: `./img/logo/dunobil.png`,
      filter: [`вертолет`],
      code: false,
      link: `https://dunobil.ru/stromwireless`,
    },
    6: {
      images: `./img/catalog/hyundai/HYUNDAI-H-MC300.png`,
      title: `HYUNDAI H-MC300`,
      text: `Cаундбар обеспечит качественную звукопередачу и полное погружение в атмосферу происходящего на экране.`,
      logoImages: `./img/logo/hyundai.png`,
      filter: [`подарок`],
      code: false,
      link: `https://hyundai-electronics.com.ru/catalog/item/1214631/?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
    7: {
      images: `./img/catalog/dunobil/Dunobil-Luft-Klein.png`,
      title: `Dunobil Luft Klein`,
      text: `Очень компактный и достаточно мощный цифровой беспроводной автокомпрессор <a href="https://shop.dunobil.ru/product/luft_klein.html" target="_blank" rel="noopener noreferrer">Dunobil Luft Klein</a>. Легко помещается в перчаточном ящике. Работает еще и как power-bank`,
      logoImages: `./img/logo/dunobil.png`,
      filter: [`звезда`],
      code: false,
      link: `https://shop.dunobil.ru/product/luft_klein.html`,
    },
    8: {
      images: `./img/catalog/hyundai/HYUNDAI-H-MC160.png`,
      title: `HYUNDAI H-MC160`,
      text: `Стильная портативная акустика <a href="https://hyundai-electronics.com.ru/catalog/item/1098376?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt" target="_blank" rel="noopener noreferrer">Hyundai H-MC160</a>, с переливающейся подсветкой корпуса устройства, поможет вам устроить вечеринку.`,
      logoImages: `./img/logo/hyundai.png`,
      filter: [`салют`],
      code: false,
      link: `https://hyundai-electronics.com.ru/catalog/item/1098376?utm_source=merlion_hyundai&utm_medium=cpc&utm_campaign=womanhit_23_specprojekt`,
    },
  },
};
